export default "__VITE_PUBLIC_ASSET__fd5af566__"